// This file is auto-generated. Do not edit manually.
import { GermanState } from '../types/GermanState';
import { HolidayData } from '../types/holiday';

export const holidays: HolidayData = {
  schoolHolidays: {
    "2024": {
      "BW": [
        {
          "name": "osterferien baden-württemberg 2024",
          "start": "2024-03-23",
          "end": "2024-04-05"
        },
        {
          "name": "pfingstferien baden-württemberg 2024",
          "start": "2024-05-21",
          "end": "2024-05-31"
        },
        {
          "name": "sommerferien baden-württemberg 2024",
          "start": "2024-07-25",
          "end": "2024-09-07"
        },
        {
          "name": "herbstferien baden-württemberg 2024",
          "start": "2024-10-28",
          "end": "2024-10-30"
        },
        {
          "name": "herbstferien baden-württemberg 2024 (beweglicher ferientag)",
          "start": "2024-10-31",
          "end": "2024-10-31"
        },
        {
          "name": "weihnachtsferien baden-württemberg 2024",
          "start": "2024-12-23",
          "end": "2025-01-04"
        }
      ],
      "BY": [
        {
          "name": "winterferien bayern 2024",
          "start": "2024-02-12",
          "end": "2024-02-16"
        },
        {
          "name": "osterferien bayern 2024",
          "start": "2024-03-25",
          "end": "2024-04-06"
        },
        {
          "name": "pfingstferien bayern 2024",
          "start": "2024-05-21",
          "end": "2024-06-01"
        },
        {
          "name": "sommerferien bayern 2024",
          "start": "2024-07-29",
          "end": "2024-09-09"
        },
        {
          "name": "herbstferien bayern 2024",
          "start": "2024-10-28",
          "end": "2024-10-31"
        },
        {
          "name": "herbstferien bayern 2024 (beweglicher ferientag)",
          "start": "2024-11-20",
          "end": "2024-11-20"
        },
        {
          "name": "weihnachtsferien bayern 2024",
          "start": "2024-12-23",
          "end": "2025-01-03"
        }
      ],
      "BE": [
        {
          "name": "winterferien berlin 2024",
          "start": "2024-02-05",
          "end": "2024-02-10"
        },
        {
          "name": "osterferien berlin 2024",
          "start": "2024-03-25",
          "end": "2024-04-05"
        },
        {
          "name": "pfingstferien berlin 2024 (beweglicher ferientag)",
          "start": "2024-05-10",
          "end": "2024-05-10"
        },
        {
          "name": "sommerferien berlin 2024",
          "start": "2024-07-18",
          "end": "2024-08-30"
        },
        {
          "name": "herbstferien berlin 2024 (beweglicher ferientag)",
          "start": "2024-10-04",
          "end": "2024-10-04"
        },
        {
          "name": "herbstferien berlin 2024",
          "start": "2024-10-21",
          "end": "2024-11-02"
        },
        {
          "name": "weihnachtsferien berlin 2024",
          "start": "2024-12-23",
          "end": "2024-12-31"
        }
      ],
      "BB": [
        {
          "name": "winterferien brandenburg 2024",
          "start": "2024-02-05",
          "end": "2024-02-09"
        },
        {
          "name": "osterferien brandenburg 2024",
          "start": "2024-03-25",
          "end": "2024-04-05"
        },
        {
          "name": "sommerferien brandenburg 2024",
          "start": "2024-07-18",
          "end": "2024-08-31"
        },
        {
          "name": "herbstferien brandenburg 2024 (beweglicher ferientag)",
          "start": "2024-10-04",
          "end": "2024-10-04"
        },
        {
          "name": "herbstferien brandenburg 2024",
          "start": "2024-10-21",
          "end": "2024-11-02"
        },
        {
          "name": "weihnachtsferien brandenburg 2024",
          "start": "2024-12-23",
          "end": "2024-12-31"
        }
      ],
      "HB": [
        {
          "name": "winterferien bremen 2024",
          "start": "2024-02-01",
          "end": "2024-02-02"
        },
        {
          "name": "osterferien bremen 2024",
          "start": "2024-03-18",
          "end": "2024-03-28"
        },
        {
          "name": "pfingstferien bremen 2024 (beweglicher ferientag)",
          "start": "2024-05-10",
          "end": "2024-05-10"
        },
        {
          "name": "sommerferien bremen 2024",
          "start": "2024-06-24",
          "end": "2024-08-02"
        },
        {
          "name": "herbstferien bremen 2024",
          "start": "2024-10-04",
          "end": "2024-10-19"
        },
        {
          "name": "herbstferien bremen 2024 (beweglicher ferientag)",
          "start": "2024-11-01",
          "end": "2024-11-01"
        },
        {
          "name": "weihnachtsferien bremen 2024",
          "start": "2024-12-23",
          "end": "2025-01-04"
        }
      ],
      "HH": [
        {
          "name": "winterferien hamburg 2024 (beweglicher ferientag)",
          "start": "2024-02-02",
          "end": "2024-02-02"
        },
        {
          "name": "osterferien hamburg 2024",
          "start": "2024-03-18",
          "end": "2024-03-28"
        },
        {
          "name": "pfingstferien hamburg 2024 (beweglicher ferientag)",
          "start": "2024-05-10",
          "end": "2024-05-10"
        },
        {
          "name": "pfingstferien hamburg 2024",
          "start": "2024-05-21",
          "end": "2024-05-24"
        },
        {
          "name": "sommerferien hamburg 2024",
          "start": "2024-07-18",
          "end": "2024-08-28"
        },
        {
          "name": "herbstferien hamburg 2024 (beweglicher ferientag)",
          "start": "2024-10-04",
          "end": "2024-10-04"
        },
        {
          "name": "herbstferien hamburg 2024",
          "start": "2024-10-21",
          "end": "2024-11-01"
        },
        {
          "name": "weihnachtsferien hamburg 2024",
          "start": "2024-12-20",
          "end": "2025-01-03"
        }
      ],
      "HE": [
        {
          "name": "osterferien hessen 2024",
          "start": "2024-03-25",
          "end": "2024-04-13"
        },
        {
          "name": "sommerferien hessen 2024",
          "start": "2024-07-15",
          "end": "2024-08-24"
        },
        {
          "name": "herbstferien hessen 2024",
          "start": "2024-10-14",
          "end": "2024-10-26"
        },
        {
          "name": "weihnachtsferien hessen 2024",
          "start": "2024-12-23",
          "end": "2025-01-11"
        }
      ],
      "MV": [
        {
          "name": "winterferien mecklenburg-vorpommern 2024",
          "start": "2024-02-05",
          "end": "2024-02-16"
        },
        {
          "name": "osterferien mecklenburg-vorpommern 2024",
          "start": "2024-03-25",
          "end": "2024-04-03"
        },
        {
          "name": "pfingstferien mecklenburg-vorpommern 2024 (beweglicher ferientag)",
          "start": "2024-05-10",
          "end": "2024-05-10"
        },
        {
          "name": "pfingstferien mecklenburg-vorpommern 2024",
          "start": "2024-05-17",
          "end": "2024-05-21"
        },
        {
          "name": "sommerferien mecklenburg-vorpommern 2024",
          "start": "2024-07-22",
          "end": "2024-08-31"
        },
        {
          "name": "herbstferien mecklenburg-vorpommern 2024 (beweglicher ferientag)",
          "start": "2024-10-04",
          "end": "2024-10-04"
        },
        {
          "name": "herbstferien mecklenburg-vorpommern 2024",
          "start": "2024-10-21",
          "end": "2024-10-26"
        },
        {
          "name": "weihnachtsferien mecklenburg-vorpommern 2024",
          "start": "2024-12-23",
          "end": "2025-01-06"
        }
      ],
      "NI": [
        {
          "name": "winterferien niedersachsen 2024",
          "start": "2024-02-01",
          "end": "2024-02-02"
        },
        {
          "name": "osterferien niedersachsen 2024",
          "start": "2024-03-18",
          "end": "2024-03-28"
        },
        {
          "name": "pfingstferien niedersachsen 2024 (beweglicher ferientag)",
          "start": "2024-05-10",
          "end": "2024-05-10"
        },
        {
          "name": "sommerferien niedersachsen 2024",
          "start": "2024-06-24",
          "end": "2024-08-03"
        },
        {
          "name": "herbstferien niedersachsen 2024",
          "start": "2024-10-04",
          "end": "2024-10-19"
        },
        {
          "name": "herbstferien niedersachsen 2024 (beweglicher ferientag)",
          "start": "2024-11-01",
          "end": "2024-11-01"
        },
        {
          "name": "weihnachtsferien niedersachsen 2024",
          "start": "2024-12-23",
          "end": "2025-01-04"
        }
      ],
      "NW": [
        {
          "name": "osterferien nordrhein-westfalen 2024",
          "start": "2024-03-25",
          "end": "2024-04-06"
        },
        {
          "name": "pfingstferien nordrhein-westfalen 2024 (beweglicher ferientag)",
          "start": "2024-05-21",
          "end": "2024-05-21"
        },
        {
          "name": "sommerferien nordrhein-westfalen 2024",
          "start": "2024-07-08",
          "end": "2024-08-20"
        },
        {
          "name": "herbstferien nordrhein-westfalen 2024",
          "start": "2024-10-14",
          "end": "2024-10-26"
        },
        {
          "name": "weihnachtsferien nordrhein-westfalen 2024",
          "start": "2024-12-23",
          "end": "2025-01-06"
        }
      ],
      "RP": [
        {
          "name": "osterferien rheinland-pfalz 2024",
          "start": "2024-03-25",
          "end": "2024-04-02"
        },
        {
          "name": "pfingstferien rheinland-pfalz 2024",
          "start": "2024-05-21",
          "end": "2024-05-29"
        },
        {
          "name": "sommerferien rheinland-pfalz 2024",
          "start": "2024-07-15",
          "end": "2024-08-23"
        },
        {
          "name": "herbstferien rheinland-pfalz 2024",
          "start": "2024-10-14",
          "end": "2024-10-25"
        },
        {
          "name": "weihnachtsferien rheinland-pfalz 2024",
          "start": "2024-12-23",
          "end": "2025-01-08"
        }
      ],
      "SL": [
        {
          "name": "winterferien saarland 2024",
          "start": "2024-02-12",
          "end": "2024-02-16"
        },
        {
          "name": "osterferien saarland 2024",
          "start": "2024-03-25",
          "end": "2024-04-05"
        },
        {
          "name": "pfingstferien saarland 2024",
          "start": "2024-05-21",
          "end": "2024-05-24"
        },
        {
          "name": "sommerferien saarland 2024",
          "start": "2024-07-15",
          "end": "2024-08-23"
        },
        {
          "name": "herbstferien saarland 2024",
          "start": "2024-10-14",
          "end": "2024-10-25"
        },
        {
          "name": "weihnachtsferien saarland 2024",
          "start": "2024-12-23",
          "end": "2025-01-03"
        }
      ],
      "SN": [
        {
          "name": "winterferien sachsen 2024",
          "start": "2024-02-12",
          "end": "2024-02-23"
        },
        {
          "name": "osterferien sachsen 2024",
          "start": "2024-03-28",
          "end": "2024-04-05"
        },
        {
          "name": "pfingstferien sachsen 2024 (beweglicher ferientag)",
          "start": "2024-05-10",
          "end": "2024-05-10"
        },
        {
          "name": "pfingstferien sachsen 2024",
          "start": "2024-05-18",
          "end": "2024-05-21"
        },
        {
          "name": "sommerferien sachsen 2024",
          "start": "2024-06-20",
          "end": "2024-08-02"
        },
        {
          "name": "herbstferien sachsen 2024",
          "start": "2024-10-07",
          "end": "2024-10-19"
        },
        {
          "name": "weihnachtsferien sachsen 2024",
          "start": "2024-12-23",
          "end": "2025-01-03"
        }
      ],
      "ST": [
        {
          "name": "winterferien sachsen-anhalt 2024",
          "start": "2024-02-05",
          "end": "2024-02-10"
        },
        {
          "name": "osterferien sachsen-anhalt 2024",
          "start": "2024-03-25",
          "end": "2024-03-30"
        },
        {
          "name": "pfingstferien sachsen-anhalt 2024",
          "start": "2024-05-21",
          "end": "2024-05-24"
        },
        {
          "name": "sommerferien sachsen-anhalt 2024",
          "start": "2024-06-24",
          "end": "2024-08-03"
        },
        {
          "name": "herbstferien sachsen-anhalt 2024",
          "start": "2024-09-30",
          "end": "2024-10-12"
        },
        {
          "name": "herbstferien sachsen-anhalt 2024 (beweglicher ferientag)",
          "start": "2024-11-01",
          "end": "2024-11-01"
        },
        {
          "name": "weihnachtsferien sachsen-anhalt 2024",
          "start": "2024-12-23",
          "end": "2025-01-04"
        }
      ],
      "SH": [
        {
          "name": "osterferien schleswig-holstein 2024",
          "start": "2024-04-02",
          "end": "2024-04-19"
        },
        {
          "name": "pfingstferien schleswig-holstein 2024",
          "start": "2024-05-10",
          "end": "2024-05-11"
        },
        {
          "name": "sommerferien schleswig-holstein 2024",
          "start": "2024-07-22",
          "end": "2024-08-31"
        },
        {
          "name": "herbstferien schleswig-holstein 2024 (beweglicher ferientag)",
          "start": "2024-10-04",
          "end": "2024-10-04"
        },
        {
          "name": "herbstferien schleswig-holstein 2024",
          "start": "2024-10-21",
          "end": "2024-11-01"
        },
        {
          "name": "weihnachtsferien schleswig-holstein 2024",
          "start": "2024-12-19",
          "end": "2025-01-07"
        }
      ],
      "TH": [
        {
          "name": "winterferien thüringen 2024",
          "start": "2024-02-12",
          "end": "2024-02-16"
        },
        {
          "name": "osterferien thüringen 2024",
          "start": "2024-03-25",
          "end": "2024-04-06"
        },
        {
          "name": "pfingstferien thüringen 2024 (beweglicher ferientag)",
          "start": "2024-05-10",
          "end": "2024-05-10"
        },
        {
          "name": "sommerferien thüringen 2024",
          "start": "2024-06-20",
          "end": "2024-07-31"
        },
        {
          "name": "herbstferien thüringen 2024",
          "start": "2024-09-30",
          "end": "2024-10-12"
        },
        {
          "name": "weihnachtsferien thüringen 2024",
          "start": "2024-12-23",
          "end": "2025-01-03"
        }
      ]
    },
    "2025": {
      "BW": [
        {
          "name": "osterferien baden-württemberg 2025",
          "start": "2025-04-14",
          "end": "2025-04-26"
        },
        {
          "name": "pfingstferien baden-württemberg 2025",
          "start": "2025-06-10",
          "end": "2025-06-20"
        },
        {
          "name": "sommerferien baden-württemberg 2025",
          "start": "2025-07-31",
          "end": "2025-09-13"
        },
        {
          "name": "herbstferien baden-württemberg 2025",
          "start": "2025-10-27",
          "end": "2025-10-30"
        },
        {
          "name": "herbstferien baden-württemberg 2025 (beweglicher ferientag)",
          "start": "2025-10-31",
          "end": "2025-10-31"
        },
        {
          "name": "weihnachtsferien baden-württemberg 2025",
          "start": "2025-12-22",
          "end": "2026-01-05"
        }
      ],
      "BY": [
        {
          "name": "winterferien bayern 2025",
          "start": "2025-03-03",
          "end": "2025-03-07"
        },
        {
          "name": "osterferien bayern 2025",
          "start": "2025-04-14",
          "end": "2025-04-25"
        },
        {
          "name": "pfingstferien bayern 2025",
          "start": "2025-06-10",
          "end": "2025-06-20"
        },
        {
          "name": "sommerferien bayern 2025",
          "start": "2025-08-01",
          "end": "2025-09-15"
        },
        {
          "name": "herbstferien bayern 2025",
          "start": "2025-11-03",
          "end": "2025-11-07"
        },
        {
          "name": "herbstferien bayern 2025 (beweglicher ferientag)",
          "start": "2025-11-19",
          "end": "2025-11-19"
        },
        {
          "name": "weihnachtsferien bayern 2025",
          "start": "2025-12-22",
          "end": "2026-01-05"
        }
      ],
      "BE": [
        {
          "name": "winterferien berlin 2025",
          "start": "2025-02-03",
          "end": "2025-02-08"
        },
        {
          "name": "osterferien berlin 2025",
          "start": "2025-04-14",
          "end": "2025-04-25"
        },
        {
          "name": "osterferien berlin 2025 (beweglicher ferientag)",
          "start": "2025-05-02",
          "end": "2025-05-02"
        },
        {
          "name": "pfingstferien berlin 2025",
          "start": "2025-06-10",
          "end": "2025-06-10"
        },
        {
          "name": "sommerferien berlin 2025",
          "start": "2025-07-24",
          "end": "2025-09-06"
        },
        {
          "name": "herbstferien berlin 2025",
          "start": "2025-10-20",
          "end": "2025-11-01"
        },
        {
          "name": "weihnachtsferien berlin 2025",
          "start": "2025-12-22",
          "end": "2026-01-02"
        }
      ],
      "BB": [
        {
          "name": "winterferien brandenburg 2025",
          "start": "2025-02-03",
          "end": "2025-02-08"
        },
        {
          "name": "osterferien brandenburg 2025",
          "start": "2025-04-14",
          "end": "2025-04-25"
        },
        {
          "name": "osterferien brandenburg 2025 (beweglicher ferientag)",
          "start": "2025-05-02",
          "end": "2025-05-02"
        },
        {
          "name": "pfingstferien brandenburg 2025",
          "start": "2025-06-10",
          "end": "2025-06-10"
        },
        {
          "name": "sommerferien brandenburg 2025",
          "start": "2025-07-24",
          "end": "2025-09-06"
        },
        {
          "name": "herbstferien brandenburg 2025",
          "start": "2025-10-20",
          "end": "2025-11-01"
        },
        {
          "name": "weihnachtsferien brandenburg 2025",
          "start": "2025-12-22",
          "end": "2026-01-02"
        }
      ],
      "HB": [
        {
          "name": "winterferien bremen 2025",
          "start": "2025-02-03",
          "end": "2025-02-04"
        },
        {
          "name": "osterferien bremen 2025",
          "start": "2025-04-07",
          "end": "2025-04-19"
        },
        {
          "name": "pfingstferien bremen 2025",
          "start": "2025-04-30",
          "end": "2025-04-30"
        },
        {
          "name": "pfingstferien bremen 2025 (beweglicher ferientag)",
          "start": "2025-05-02",
          "end": "2025-05-02"
        },
        {
          "name": "sommerferien bremen 2025",
          "start": "2025-07-03",
          "end": "2025-08-13"
        },
        {
          "name": "herbstferien bremen 2025",
          "start": "2025-10-13",
          "end": "2025-10-25"
        },
        {
          "name": "weihnachtsferien bremen 2025",
          "start": "2025-12-22",
          "end": "2026-01-05"
        }
      ],
      "HH": [
        {
          "name": "winterferien hamburg 2025",
          "start": "2025-01-31",
          "end": "2025-01-31"
        },
        {
          "name": "osterferien hamburg 2025",
          "start": "2025-03-10",
          "end": "2025-03-21"
        },
        {
          "name": "pfingstferien hamburg 2025",
          "start": "2025-05-02",
          "end": "2025-05-02"
        },
        {
          "name": "pfingstferien hamburg 2025 (beweglicher ferientag)",
          "start": "2025-05-26",
          "end": "2025-05-30"
        },
        {
          "name": "sommerferien hamburg 2025",
          "start": "2025-07-24",
          "end": "2025-09-03"
        },
        {
          "name": "herbstferien hamburg 2025",
          "start": "2025-10-20",
          "end": "2025-10-31"
        },
        {
          "name": "weihnachtsferien hamburg 2025",
          "start": "2025-12-17",
          "end": "2026-01-02"
        }
      ],
      "HE": [
        {
          "name": "osterferien hessen 2025",
          "start": "2025-04-07",
          "end": "2025-04-21"
        },
        {
          "name": "sommerferien hessen 2025",
          "start": "2025-07-07",
          "end": "2025-08-15"
        },
        {
          "name": "herbstferien hessen 2025",
          "start": "2025-10-06",
          "end": "2025-10-18"
        },
        {
          "name": "weihnachtsferien hessen 2025",
          "start": "2025-12-22",
          "end": "2026-01-10"
        }
      ],
      "MV": [
        {
          "name": "winterferien mecklenburg-vorpommern 2025",
          "start": "2025-02-03",
          "end": "2025-02-14"
        },
        {
          "name": "osterferien mecklenburg-vorpommern 2025",
          "start": "2025-04-14",
          "end": "2025-04-23"
        },
        {
          "name": "osterferien mecklenburg-vorpommern 2025 (beweglicher ferientag)",
          "start": "2025-05-30",
          "end": "2025-05-30"
        },
        {
          "name": "pfingstferien mecklenburg-vorpommern 2025",
          "start": "2025-06-06",
          "end": "2025-06-10"
        },
        {
          "name": "sommerferien mecklenburg-vorpommern 2025",
          "start": "2025-07-28",
          "end": "2025-09-06"
        },
        {
          "name": "herbstferien mecklenburg-vorpommern 2025",
          "start": "2025-10-02",
          "end": "2025-10-02"
        },
        {
          "name": "herbstferien mecklenburg-vorpommern 2025 (beweglicher ferientag)",
          "start": "2025-10-20",
          "end": "2025-10-25"
        },
        {
          "name": "weihnachtsferien mecklenburg-vorpommern 2025",
          "start": "2025-12-22",
          "end": "2026-01-05"
        }
      ],
      "NI": [
        {
          "name": "winterferien niedersachsen 2025",
          "start": "2025-02-03",
          "end": "2025-02-04"
        },
        {
          "name": "osterferien niedersachsen 2025",
          "start": "2025-04-07",
          "end": "2025-04-19"
        },
        {
          "name": "osterferien niedersachsen 2025 (beweglicher ferientag)",
          "start": "2025-04-30",
          "end": "2025-04-30"
        },
        {
          "name": "pfingstferien niedersachsen 2025",
          "start": "2025-05-02",
          "end": "2025-05-02"
        },
        {
          "name": "pfingstferien niedersachsen 2025 (beweglicher ferientag)",
          "start": "2025-05-30",
          "end": "2025-05-30"
        },
        {
          "name": "sommerferien niedersachsen 2025",
          "start": "2025-07-03",
          "end": "2025-08-13"
        },
        {
          "name": "herbstferien niedersachsen 2025",
          "start": "2025-10-13",
          "end": "2025-10-25"
        },
        {
          "name": "weihnachtsferien niedersachsen 2025",
          "start": "2025-12-22",
          "end": "2026-01-05"
        }
      ],
      "NW": [
        {
          "name": "osterferien nordrhein-westfalen 2025",
          "start": "2025-04-14",
          "end": "2025-04-26"
        },
        {
          "name": "pfingstferien nordrhein-westfalen 2025",
          "start": "2025-06-10",
          "end": "2025-06-10"
        },
        {
          "name": "sommerferien nordrhein-westfalen 2025",
          "start": "2025-07-14",
          "end": "2025-08-26"
        },
        {
          "name": "herbstferien nordrhein-westfalen 2025",
          "start": "2025-10-13",
          "end": "2025-10-25"
        },
        {
          "name": "weihnachtsferien nordrhein-westfalen 2025",
          "start": "2025-12-22",
          "end": "2026-01-06"
        }
      ],
      "RP": [
        {
          "name": "osterferien rheinland-pfalz 2025",
          "start": "2025-04-14",
          "end": "2025-04-25"
        },
        {
          "name": "sommerferien rheinland-pfalz 2025",
          "start": "2025-07-07",
          "end": "2025-08-15"
        },
        {
          "name": "herbstferien rheinland-pfalz 2025",
          "start": "2025-10-13",
          "end": "2025-10-24"
        },
        {
          "name": "weihnachtsferien rheinland-pfalz 2025",
          "start": "2025-12-22",
          "end": "2026-01-07"
        }
      ],
      "SL": [
        {
          "name": "winterferien saarland 2025",
          "start": "2025-02-24",
          "end": "2025-03-04"
        },
        {
          "name": "osterferien saarland 2025",
          "start": "2025-04-14",
          "end": "2025-04-25"
        },
        {
          "name": "sommerferien saarland 2025",
          "start": "2025-07-07",
          "end": "2025-08-14"
        },
        {
          "name": "herbstferien saarland 2025",
          "start": "2025-10-13",
          "end": "2025-10-24"
        },
        {
          "name": "weihnachtsferien saarland 2025",
          "start": "2025-12-22",
          "end": "2026-01-02"
        }
      ],
      "SN": [
        {
          "name": "winterferien sachsen 2025",
          "start": "2025-02-17",
          "end": "2025-03-01"
        },
        {
          "name": "osterferien sachsen 2025",
          "start": "2025-04-18",
          "end": "2025-04-25"
        },
        {
          "name": "osterferien sachsen 2025 (beweglicher ferientag)",
          "start": "2025-05-30",
          "end": "2025-05-30"
        },
        {
          "name": "sommerferien sachsen 2025",
          "start": "2025-06-28",
          "end": "2025-08-08"
        },
        {
          "name": "herbstferien sachsen 2025",
          "start": "2025-10-06",
          "end": "2025-10-18"
        },
        {
          "name": "weihnachtsferien sachsen 2025",
          "start": "2025-12-22",
          "end": "2026-01-02"
        }
      ],
      "ST": [
        {
          "name": "winterferien sachsen-anhalt 2025",
          "start": "2025-01-27",
          "end": "2025-01-31"
        },
        {
          "name": "osterferien sachsen-anhalt 2025",
          "start": "2025-04-07",
          "end": "2025-04-19"
        },
        {
          "name": "pfingstferien sachsen-anhalt 2025",
          "start": "2025-05-30",
          "end": "2025-05-30"
        },
        {
          "name": "sommerferien sachsen-anhalt 2025",
          "start": "2025-06-28",
          "end": "2025-08-08"
        },
        {
          "name": "herbstferien sachsen-anhalt 2025",
          "start": "2025-10-13",
          "end": "2025-10-25"
        },
        {
          "name": "weihnachtsferien sachsen-anhalt 2025",
          "start": "2025-12-22",
          "end": "2026-01-05"
        }
      ],
      "SH": [
        {
          "name": "winterferien schleswig-holstein 2025",
          "start": "2025-02-03",
          "end": "2025-02-03"
        },
        {
          "name": "osterferien schleswig-holstein 2025",
          "start": "2025-04-11",
          "end": "2025-04-25"
        },
        {
          "name": "osterferien schleswig-holstein 2025 (beweglicher ferientag)",
          "start": "2025-05-02",
          "end": "2025-05-02"
        },
        {
          "name": "pfingstferien schleswig-holstein 2025",
          "start": "2025-05-30",
          "end": "2025-05-30"
        },
        {
          "name": "sommerferien schleswig-holstein 2025",
          "start": "2025-07-28",
          "end": "2025-09-06"
        },
        {
          "name": "herbstferien schleswig-holstein 2025",
          "start": "2025-10-20",
          "end": "2025-10-30"
        },
        {
          "name": "herbstferien schleswig-holstein 2025 (beweglicher ferientag)",
          "start": "2025-11-28",
          "end": "2025-11-28"
        },
        {
          "name": "weihnachtsferien schleswig-holstein 2025",
          "start": "2025-12-19",
          "end": "2026-01-06"
        }
      ],
      "TH": [
        {
          "name": "winterferien thüringen 2025",
          "start": "2025-02-03",
          "end": "2025-02-08"
        },
        {
          "name": "osterferien thüringen 2025",
          "start": "2025-04-07",
          "end": "2025-04-19"
        },
        {
          "name": "pfingstferien thüringen 2025",
          "start": "2025-05-30",
          "end": "2025-05-30"
        },
        {
          "name": "sommerferien thüringen 2025",
          "start": "2025-06-28",
          "end": "2025-08-08"
        },
        {
          "name": "herbstferien thüringen 2025",
          "start": "2025-10-06",
          "end": "2025-10-18"
        },
        {
          "name": "weihnachtsferien thüringen 2025",
          "start": "2025-12-22",
          "end": "2026-01-03"
        }
      ]
    },
    "2026": {
      "BW": [
        {
          "name": "osterferien baden-württemberg 2026",
          "start": "2026-03-30",
          "end": "2026-04-12"
        },
        {
          "name": "pfingstferien baden-württemberg 2026",
          "start": "2026-05-26",
          "end": "2026-06-06"
        },
        {
          "name": "sommerferien baden-württemberg 2026",
          "start": "2026-07-30",
          "end": "2026-09-13"
        },
        {
          "name": "herbstferien baden-württemberg 2026",
          "start": "2026-10-26",
          "end": "2026-11-01"
        },
        {
          "name": "weihnachtsferien baden-württemberg 2026",
          "start": "2026-12-23",
          "end": "2027-01-10"
        }
      ],
      "BY": [
        {
          "name": "winterferien bayern 2026",
          "start": "2026-02-16",
          "end": "2026-02-20"
        },
        {
          "name": "osterferien bayern 2026",
          "start": "2026-03-30",
          "end": "2026-04-10"
        },
        {
          "name": "pfingstferien bayern 2026",
          "start": "2026-05-26",
          "end": "2026-06-05"
        },
        {
          "name": "sommerferien bayern 2026",
          "start": "2026-08-03",
          "end": "2026-09-14"
        },
        {
          "name": "herbstferien bayern 2026",
          "start": "2026-11-02",
          "end": "2026-11-06"
        },
        {
          "name": "herbstferien bayern 2026 (einzeltag)",
          "start": "2026-11-18",
          "end": "2026-11-18"
        },
        {
          "name": "weihnachtsferien bayern 2026",
          "start": "2026-12-24",
          "end": "2027-01-08"
        }
      ],
      "BE": [
        {
          "name": "winterferien berlin 2026",
          "start": "2026-02-02",
          "end": "2026-02-07"
        },
        {
          "name": "osterferien berlin 2026",
          "start": "2026-03-30",
          "end": "2026-04-10"
        },
        {
          "name": "osterferien berlin 2026 (einzeltag)",
          "start": "2026-05-15",
          "end": "2026-05-15"
        },
        {
          "name": "pfingstferien berlin 2026",
          "start": "2026-05-26",
          "end": "2026-05-26"
        },
        {
          "name": "sommerferien berlin 2026",
          "start": "2026-07-09",
          "end": "2026-08-22"
        },
        {
          "name": "herbstferien berlin 2026",
          "start": "2026-10-19",
          "end": "2026-10-31"
        },
        {
          "name": "weihnachtsferien berlin 2026",
          "start": "2026-12-23",
          "end": "2027-01-02"
        }
      ],
      "BB": [
        {
          "name": "winterferien brandenburg 2026",
          "start": "2026-02-02",
          "end": "2026-02-07"
        },
        {
          "name": "osterferien brandenburg 2026",
          "start": "2026-03-30",
          "end": "2026-04-10"
        },
        {
          "name": "osterferien brandenburg 2026 (einzeltag)",
          "start": "2026-05-15",
          "end": "2026-05-15"
        },
        {
          "name": "pfingstferien brandenburg 2026",
          "start": "2026-05-26",
          "end": "2026-05-26"
        },
        {
          "name": "sommerferien brandenburg 2026",
          "start": "2026-07-09",
          "end": "2026-08-22"
        },
        {
          "name": "herbstferien brandenburg 2026",
          "start": "2026-10-19",
          "end": "2026-10-30"
        },
        {
          "name": "weihnachtsferien brandenburg 2026",
          "start": "2026-12-23",
          "end": "2027-01-02"
        }
      ],
      "HB": [
        {
          "name": "winterferien bremen 2026",
          "start": "2026-02-02",
          "end": "2026-02-03"
        },
        {
          "name": "osterferien bremen 2026",
          "start": "2026-03-23",
          "end": "2026-04-07"
        },
        {
          "name": "osterferien bremen 2026 (einzeltag)",
          "start": "2026-05-15",
          "end": "2026-05-15"
        },
        {
          "name": "pfingstferien bremen 2026",
          "start": "2026-05-26",
          "end": "2026-05-26"
        },
        {
          "name": "sommerferien bremen 2026",
          "start": "2026-07-02",
          "end": "2026-08-12"
        },
        {
          "name": "herbstferien bremen 2026",
          "start": "2026-10-12",
          "end": "2026-10-24"
        },
        {
          "name": "weihnachtsferien bremen 2026",
          "start": "2026-12-23",
          "end": "2027-01-09"
        }
      ],
      "HH": [
        {
          "name": "winterferien hamburg 2026",
          "start": "2026-01-30",
          "end": "2026-01-30"
        },
        {
          "name": "osterferien hamburg 2026",
          "start": "2026-03-02",
          "end": "2026-03-13"
        },
        {
          "name": "pfingstferien hamburg 2026",
          "start": "2026-05-11",
          "end": "2026-05-15"
        },
        {
          "name": "sommerferien hamburg 2026",
          "start": "2026-07-09",
          "end": "2026-08-19"
        },
        {
          "name": "herbstferien hamburg 2026",
          "start": "2026-10-19",
          "end": "2026-10-30"
        },
        {
          "name": "weihnachtsferien hamburg 2026",
          "start": "2026-12-21",
          "end": "2027-01-01"
        }
      ],
      "HE": [
        {
          "name": "osterferien hessen 2026",
          "start": "2026-03-30",
          "end": "2026-04-10"
        },
        {
          "name": "sommerferien hessen 2026",
          "start": "2026-06-29",
          "end": "2026-08-07"
        },
        {
          "name": "herbstferien hessen 2026",
          "start": "2026-10-05",
          "end": "2026-10-17"
        },
        {
          "name": "weihnachtsferien hessen 2026",
          "start": "2026-12-23",
          "end": "2027-01-12"
        }
      ],
      "MV": [
        {
          "name": "winterferien mecklenburg-vorpommern 2026",
          "start": "2026-02-09",
          "end": "2026-02-20"
        },
        {
          "name": "osterferien mecklenburg-vorpommern 2026",
          "start": "2026-03-30",
          "end": "2026-04-08"
        },
        {
          "name": "osterferien mecklenburg-vorpommern 2026 (einzeltag)",
          "start": "2026-05-15",
          "end": "2026-05-15"
        },
        {
          "name": "pfingstferien mecklenburg-vorpommern 2026",
          "start": "2026-05-22",
          "end": "2026-05-26"
        },
        {
          "name": "sommerferien mecklenburg-vorpommern 2026",
          "start": "2026-07-13",
          "end": "2026-08-22"
        },
        {
          "name": "herbstferien mecklenburg-vorpommern 2026",
          "start": "2026-10-19",
          "end": "2026-10-24"
        },
        {
          "name": "herbstferien mecklenburg-vorpommern 2026 (einzeltage)",
          "start": "2026-11-26",
          "end": "2026-11-27"
        },
        {
          "name": "weihnachtsferien mecklenburg-vorpommern 2026",
          "start": "2026-12-19",
          "end": "2027-01-02"
        }
      ],
      "NI": [
        {
          "name": "winterferien niedersachsen 2026",
          "start": "2026-02-02",
          "end": "2026-02-03"
        },
        {
          "name": "osterferien niedersachsen 2026",
          "start": "2026-03-23",
          "end": "2026-04-07"
        },
        {
          "name": "osterferien niedersachsen 2026 (einzeltag)",
          "start": "2026-05-15",
          "end": "2026-05-15"
        },
        {
          "name": "pfingstferien niedersachsen 2026",
          "start": "2026-05-26",
          "end": "2026-05-26"
        },
        {
          "name": "sommerferien niedersachsen 2026",
          "start": "2026-07-02",
          "end": "2026-08-12"
        },
        {
          "name": "herbstferien niedersachsen 2026",
          "start": "2026-10-12",
          "end": "2026-10-24"
        },
        {
          "name": "weihnachtsferien niedersachsen 2026",
          "start": "2026-12-23",
          "end": "2027-01-09"
        }
      ],
      "NW": [
        {
          "name": "osterferien nordrhein-westfalen 2026",
          "start": "2026-03-30",
          "end": "2026-04-10"
        },
        {
          "name": "pfingstferien nordrhein-westfalen 2026",
          "start": "2026-05-26",
          "end": "2026-05-26"
        },
        {
          "name": "sommerferien nordrhein-westfalen 2026",
          "start": "2026-07-20",
          "end": "2026-09-01"
        },
        {
          "name": "herbstferien nordrhein-westfalen 2026",
          "start": "2026-10-19",
          "end": "2026-10-30"
        },
        {
          "name": "weihnachtsferien nordrhein-westfalen 2026",
          "start": "2026-12-23",
          "end": "2027-01-06"
        }
      ],
      "RP": [
        {
          "name": "osterferien rheinland-pfalz 2026",
          "start": "2026-03-30",
          "end": "2026-04-10"
        },
        {
          "name": "sommerferien rheinland-pfalz 2026",
          "start": "2026-06-29",
          "end": "2026-08-07"
        },
        {
          "name": "herbstferien rheinland-pfalz 2026",
          "start": "2026-10-05",
          "end": "2026-10-16"
        },
        {
          "name": "weihnachtsferien rheinland-pfalz 2026",
          "start": "2026-12-23",
          "end": "2027-01-08"
        }
      ],
      "SL": [
        {
          "name": "winterferien saarland 2026",
          "start": "2026-02-16",
          "end": "2026-02-20"
        },
        {
          "name": "osterferien saarland 2026",
          "start": "2026-04-07",
          "end": "2026-04-17"
        },
        {
          "name": "sommerferien saarland 2026",
          "start": "2026-06-29",
          "end": "2026-08-07"
        },
        {
          "name": "herbstferien saarland 2026",
          "start": "2026-10-05",
          "end": "2026-10-16"
        },
        {
          "name": "weihnachtsferien saarland 2026",
          "start": "2026-12-21",
          "end": "2026-12-31"
        }
      ],
      "SN": [
        {
          "name": "winterferien sachsen 2026",
          "start": "2026-02-09",
          "end": "2026-02-21"
        },
        {
          "name": "osterferien sachsen 2026",
          "start": "2026-04-03",
          "end": "2026-04-10"
        },
        {
          "name": "osterferien sachsen 2026 (einzeltag)",
          "start": "2026-05-15",
          "end": "2026-05-15"
        },
        {
          "name": "sommerferien sachsen 2026",
          "start": "2026-07-04",
          "end": "2026-08-14"
        },
        {
          "name": "herbstferien sachsen 2026",
          "start": "2026-10-12",
          "end": "2026-10-24"
        },
        {
          "name": "weihnachtsferien sachsen 2026",
          "start": "2026-12-23",
          "end": "2027-01-02"
        }
      ],
      "ST": [
        {
          "name": "winterferien sachsen-anhalt 2026",
          "start": "2026-01-31",
          "end": "2026-02-06"
        },
        {
          "name": "osterferien sachsen-anhalt 2026",
          "start": "2026-03-30",
          "end": "2026-04-04"
        },
        {
          "name": "pfingstferien sachsen-anhalt 2026",
          "start": "2026-05-26",
          "end": "2026-05-29"
        },
        {
          "name": "sommerferien sachsen-anhalt 2026",
          "start": "2026-07-04",
          "end": "2026-08-14"
        },
        {
          "name": "herbstferien sachsen-anhalt 2026",
          "start": "2026-10-19",
          "end": "2026-10-30"
        },
        {
          "name": "weihnachtsferien sachsen-anhalt 2026",
          "start": "2026-12-21",
          "end": "2027-01-02"
        }
      ],
      "SH": [
        {
          "name": "winterferien schleswig-holstein 2026",
          "start": "2026-02-02",
          "end": "2026-02-03"
        },
        {
          "name": "osterferien schleswig-holstein 2026",
          "start": "2026-03-26",
          "end": "2026-04-10"
        },
        {
          "name": "osterferien schleswig-holstein 2026 (einzeltag)",
          "start": "2026-05-15",
          "end": "2026-05-15"
        },
        {
          "name": "sommerferien schleswig-holstein 2026",
          "start": "2026-07-04",
          "end": "2026-08-15"
        },
        {
          "name": "herbstferien schleswig-holstein 2026",
          "start": "2026-10-12",
          "end": "2026-10-24"
        },
        {
          "name": "weihnachtsferien schleswig-holstein 2026",
          "start": "2026-12-21",
          "end": "2027-01-06"
        }
      ],
      "TH": [
        {
          "name": "winterferien thüringen 2026",
          "start": "2026-02-16",
          "end": "2026-02-21"
        },
        {
          "name": "osterferien thüringen 2026",
          "start": "2026-04-07",
          "end": "2026-04-17"
        },
        {
          "name": "osterferien thüringen 2026 (einzeltag)",
          "start": "2026-05-15",
          "end": "2026-05-15"
        },
        {
          "name": "sommerferien thüringen 2026",
          "start": "2026-07-04",
          "end": "2026-08-14"
        },
        {
          "name": "herbstferien thüringen 2026",
          "start": "2026-10-12",
          "end": "2026-10-24"
        },
        {
          "name": "weihnachtsferien thüringen 2026",
          "start": "2026-12-23",
          "end": "2027-01-02"
        }
      ]
    },
    "2027": {
      "BW": [
        {
          "name": "osterferien baden-württemberg 2027 (einzeltag)",
          "start": "2027-03-25",
          "end": "2027-03-25"
        },
        {
          "name": "osterferien baden-württemberg 2027",
          "start": "2027-03-30",
          "end": "2027-04-03"
        },
        {
          "name": "pfingstferien baden-württemberg 2027",
          "start": "2027-05-18",
          "end": "2027-05-29"
        },
        {
          "name": "sommerferien baden-württemberg 2027",
          "start": "2027-07-29",
          "end": "2027-09-11"
        },
        {
          "name": "herbstferien baden-württemberg 2027",
          "start": "2027-11-02",
          "end": "2027-11-06"
        },
        {
          "name": "weihnachtsferien baden-württemberg 2027",
          "start": "2027-12-23",
          "end": "2028-01-08"
        }
      ],
      "BY": [
        {
          "name": "winterferien bayern 2027",
          "start": "2027-02-08",
          "end": "2027-02-12"
        },
        {
          "name": "osterferien bayern 2027",
          "start": "2027-03-22",
          "end": "2027-04-02"
        },
        {
          "name": "pfingstferien bayern 2027",
          "start": "2027-05-18",
          "end": "2027-05-28"
        },
        {
          "name": "sommerferien bayern 2027",
          "start": "2027-08-02",
          "end": "2027-09-13"
        },
        {
          "name": "herbstferien bayern 2027",
          "start": "2027-11-02",
          "end": "2027-11-05"
        },
        {
          "name": "herbstferien bayern 2027 (einzeltag)",
          "start": "2027-11-17",
          "end": "2027-11-17"
        },
        {
          "name": "weihnachtsferien bayern 2027",
          "start": "2027-12-24",
          "end": "2028-01-07"
        }
      ],
      "BE": [
        {
          "name": "winterferien berlin 2027",
          "start": "2027-02-01",
          "end": "2027-02-06"
        },
        {
          "name": "osterferien berlin 2027",
          "start": "2027-03-22",
          "end": "2027-04-02"
        },
        {
          "name": "osterferien berlin 2027 (einzeltag)",
          "start": "2027-05-07",
          "end": "2027-05-07"
        },
        {
          "name": "pfingstferien berlin 2027",
          "start": "2027-05-18",
          "end": "2027-05-19"
        },
        {
          "name": "sommerferien berlin 2027",
          "start": "2027-07-01",
          "end": "2027-08-14"
        },
        {
          "name": "herbstferien berlin 2027",
          "start": "2027-10-11",
          "end": "2027-10-23"
        },
        {
          "name": "weihnachtsferien berlin 2027",
          "start": "2027-12-22",
          "end": "2027-12-31"
        }
      ],
      "BB": [
        {
          "name": "winterferien brandenburg 2027",
          "start": "2027-02-01",
          "end": "2027-02-06"
        },
        {
          "name": "osterferien brandenburg 2027",
          "start": "2027-03-22",
          "end": "2027-04-03"
        },
        {
          "name": "osterferien brandenburg 2027 (einzeltag)",
          "start": "2027-05-07",
          "end": "2027-05-07"
        },
        {
          "name": "pfingstferien brandenburg 2027",
          "start": "2027-05-18",
          "end": "2027-05-18"
        },
        {
          "name": "sommerferien brandenburg 2027",
          "start": "2027-07-01",
          "end": "2027-08-14"
        },
        {
          "name": "herbstferien brandenburg 2027",
          "start": "2027-10-11",
          "end": "2027-10-23"
        },
        {
          "name": "weihnachtsferien brandenburg 2027",
          "start": "2027-12-23",
          "end": "2027-12-31"
        }
      ],
      "HB": [
        {
          "name": "winterferien bremen 2027",
          "start": "2027-02-01",
          "end": "2027-02-02"
        },
        {
          "name": "osterferien bremen 2027",
          "start": "2027-03-22",
          "end": "2027-04-03"
        },
        {
          "name": "osterferien bremen 2027 (einzeltag)",
          "start": "2027-05-07",
          "end": "2027-05-07"
        },
        {
          "name": "pfingstferien bremen 2027",
          "start": "2027-05-18",
          "end": "2027-05-18"
        },
        {
          "name": "sommerferien bremen 2027",
          "start": "2027-07-08",
          "end": "2027-08-18"
        },
        {
          "name": "herbstferien bremen 2027",
          "start": "2027-10-18",
          "end": "2027-10-30"
        },
        {
          "name": "weihnachtsferien bremen 2027",
          "start": "2027-12-23",
          "end": "2028-01-08"
        }
      ],
      "HH": [
        {
          "name": "winterferien hamburg 2027",
          "start": "2027-01-29",
          "end": "2027-01-29"
        },
        {
          "name": "osterferien hamburg 2027",
          "start": "2027-03-01",
          "end": "2027-03-12"
        },
        {
          "name": "pfingstferien hamburg 2027",
          "start": "2027-05-07",
          "end": "2027-05-14"
        },
        {
          "name": "sommerferien hamburg 2027",
          "start": "2027-07-01",
          "end": "2027-08-11"
        },
        {
          "name": "herbstferien hamburg 2027",
          "start": "2027-10-11",
          "end": "2027-10-22"
        },
        {
          "name": "weihnachtsferien hamburg 2027",
          "start": "2027-12-20",
          "end": "2027-12-31"
        }
      ],
      "HE": [
        {
          "name": "osterferien hessen 2027",
          "start": "2027-03-22",
          "end": "2027-04-02"
        },
        {
          "name": "sommerferien hessen 2027",
          "start": "2027-06-28",
          "end": "2027-08-06"
        },
        {
          "name": "herbstferien hessen 2027",
          "start": "2027-10-04",
          "end": "2027-10-16"
        },
        {
          "name": "weihnachtsferien hessen 2027",
          "start": "2027-12-23",
          "end": "2028-01-11"
        }
      ],
      "MV": [
        {
          "name": "winterferien mecklenburg-vorpommern 2027",
          "start": "2027-02-08",
          "end": "2027-02-19"
        },
        {
          "name": "osterferien mecklenburg-vorpommern 2027",
          "start": "2027-03-24",
          "end": "2027-04-02"
        },
        {
          "name": "osterferien mecklenburg-vorpommern 2027 (einzeltag)",
          "start": "2027-05-07",
          "end": "2027-05-07"
        },
        {
          "name": "pfingstferien mecklenburg-vorpommern 2027",
          "start": "2027-05-14",
          "end": "2027-05-18"
        },
        {
          "name": "sommerferien mecklenburg-vorpommern 2027",
          "start": "2027-07-05",
          "end": "2027-08-14"
        },
        {
          "name": "herbstferien mecklenburg-vorpommern 2027",
          "start": "2027-10-14",
          "end": "2027-10-23"
        },
        {
          "name": "weihnachtsferien mecklenburg-vorpommern 2027",
          "start": "2027-12-22",
          "end": "2028-01-04"
        }
      ],
      "NI": [
        {
          "name": "winterferien niedersachsen 2027",
          "start": "2027-02-01",
          "end": "2027-02-02"
        },
        {
          "name": "osterferien niedersachsen 2027",
          "start": "2027-03-22",
          "end": "2027-04-03"
        },
        {
          "name": "osterferien niedersachsen 2027 (einzeltag)",
          "start": "2027-05-07",
          "end": "2027-05-07"
        },
        {
          "name": "pfingstferien niedersachsen 2027",
          "start": "2027-05-18",
          "end": "2027-05-18"
        },
        {
          "name": "sommerferien niedersachsen 2027",
          "start": "2027-07-08",
          "end": "2027-08-18"
        },
        {
          "name": "herbstferien niedersachsen 2027",
          "start": "2027-10-16",
          "end": "2027-10-30"
        },
        {
          "name": "weihnachtsferien niedersachsen 2027",
          "start": "2027-12-23",
          "end": "2028-01-08"
        }
      ],
      "NW": [
        {
          "name": "osterferien nordrhein-westfalen 2027",
          "start": "2027-03-22",
          "end": "2027-04-03"
        },
        {
          "name": "pfingstferien nordrhein-westfalen 2027",
          "start": "2027-05-18",
          "end": "2027-05-18"
        },
        {
          "name": "sommerferien nordrhein-westfalen 2027",
          "start": "2027-07-19",
          "end": "2027-08-31"
        },
        {
          "name": "herbstferien nordrhein-westfalen 2027",
          "start": "2027-10-23",
          "end": "2027-11-06"
        },
        {
          "name": "weihnachtsferien nordrhein-westfalen 2027",
          "start": "2027-12-24",
          "end": "2028-01-08"
        }
      ],
      "RP": [
        {
          "name": "osterferien rheinland-pfalz 2027",
          "start": "2027-03-22",
          "end": "2027-04-02"
        },
        {
          "name": "sommerferien rheinland-pfalz 2027",
          "start": "2027-06-28",
          "end": "2027-08-06"
        },
        {
          "name": "herbstferien rheinland-pfalz 2027",
          "start": "2027-10-04",
          "end": "2027-10-15"
        },
        {
          "name": "weihnachtsferien rheinland-pfalz 2027",
          "start": "2027-12-23",
          "end": "2028-01-07"
        }
      ],
      "SL": [
        {
          "name": "winterferien saarland 2027",
          "start": "2027-02-08",
          "end": "2027-02-12"
        },
        {
          "name": "osterferien saarland 2027",
          "start": "2027-03-30",
          "end": "2027-04-09"
        },
        {
          "name": "sommerferien saarland 2027",
          "start": "2027-06-28",
          "end": "2027-08-06"
        },
        {
          "name": "herbstferien saarland 2027",
          "start": "2027-10-04",
          "end": "2027-10-15"
        },
        {
          "name": "weihnachtsferien saarland 2027",
          "start": "2027-12-20",
          "end": "2027-12-31"
        }
      ],
      "SN": [
        {
          "name": "winterferien sachsen 2027",
          "start": "2027-02-08",
          "end": "2027-02-19"
        },
        {
          "name": "osterferien sachsen 2027",
          "start": "2027-03-26",
          "end": "2027-04-02"
        },
        {
          "name": "osterferien sachsen 2027 (einzeltag)",
          "start": "2027-05-07",
          "end": "2027-05-07"
        },
        {
          "name": "pfingstferien sachsen 2027",
          "start": "2027-05-15",
          "end": "2027-05-18"
        },
        {
          "name": "sommerferien sachsen 2027",
          "start": "2027-07-10",
          "end": "2027-08-20"
        },
        {
          "name": "herbstferien sachsen 2027",
          "start": "2027-10-11",
          "end": "2027-10-23"
        },
        {
          "name": "weihnachtsferien sachsen 2027",
          "start": "2027-12-23",
          "end": "2028-01-01"
        }
      ],
      "ST": [
        {
          "name": "winterferien sachsen-anhalt 2027",
          "start": "2027-02-01",
          "end": "2027-02-06"
        },
        {
          "name": "osterferien sachsen-anhalt 2027",
          "start": "2027-03-22",
          "end": "2027-03-27"
        },
        {
          "name": "pfingstferien sachsen-anhalt 2027",
          "start": "2027-05-15",
          "end": "2027-05-22"
        },
        {
          "name": "sommerferien sachsen-anhalt 2027",
          "start": "2027-07-10",
          "end": "2027-08-20"
        },
        {
          "name": "herbstferien sachsen-anhalt 2027",
          "start": "2027-10-18",
          "end": "2027-10-23"
        },
        {
          "name": "weihnachtsferien sachsen-anhalt 2027",
          "start": "2027-12-20",
          "end": "2027-12-31"
        }
      ],
      "SH": [
        {
          "name": "osterferien schleswig-holstein 2027",
          "start": "2027-03-30",
          "end": "2027-04-10"
        },
        {
          "name": "osterferien schleswig-holstein 2027 (einzeltag)",
          "start": "2027-05-07",
          "end": "2027-05-07"
        },
        {
          "name": "sommerferien schleswig-holstein 2027",
          "start": "2027-07-03",
          "end": "2027-08-14"
        },
        {
          "name": "herbstferien schleswig-holstein 2027",
          "start": "2027-10-11",
          "end": "2027-10-23"
        },
        {
          "name": "weihnachtsferien schleswig-holstein 2027",
          "start": "2027-12-23",
          "end": "2028-01-08"
        }
      ],
      "TH": [
        {
          "name": "winterferien thüringen 2027",
          "start": "2027-02-01",
          "end": "2027-02-06"
        },
        {
          "name": "osterferien thüringen 2027",
          "start": "2027-03-22",
          "end": "2027-04-03"
        },
        {
          "name": "osterferien thüringen 2027 (einzeltag)",
          "start": "2027-05-07",
          "end": "2027-05-07"
        },
        {
          "name": "sommerferien thüringen 2027",
          "start": "2027-07-10",
          "end": "2027-08-20"
        },
        {
          "name": "herbstferien thüringen 2027",
          "start": "2027-10-09",
          "end": "2027-10-23"
        },
        {
          "name": "weihnachtsferien thüringen 2027",
          "start": "2027-12-23",
          "end": "2027-12-31"
        }
      ]
    }
  },
  publicHolidays: {
    "2024": {
      "ALL": [
        {
          "name": "Neujahr",
          "start": "2024-01-01",
          "nationwide": true
        },
        {
          "name": "Karfreitag",
          "start": "2024-03-29",
          "nationwide": true
        },
        {
          "name": "Ostermontag",
          "start": "2024-04-01",
          "nationwide": true
        },
        {
          "name": "Tag der Arbeit",
          "start": "2024-05-01",
          "nationwide": true
        },
        {
          "name": "Christi Himmelfahrt",
          "start": "2024-05-09",
          "nationwide": true
        },
        {
          "name": "Pfingstmontag",
          "start": "2024-05-20",
          "nationwide": true
        },
        {
          "name": "Tag der Deutschen Einheit",
          "start": "2024-10-03",
          "nationwide": true
        },
        {
          "name": "1. Weihnachtstag",
          "start": "2024-12-25",
          "nationwide": true
        },
        {
          "name": "2. Weihnachtstag",
          "start": "2024-12-26",
          "nationwide": true
        }
      ],
      "BW": [
        {
          "name": "Heilige Drei Könige",
          "start": "2024-01-06"
        },
        {
          "name": "Fronleichnam",
          "start": "2024-05-30"
        },
        {
          "name": "Allerheiligen",
          "start": "2024-11-01"
        }
      ],
      "BY": [
        {
          "name": "Heilige Drei Könige",
          "start": "2024-01-06"
        },
        {
          "name": "Fronleichnam",
          "start": "2024-05-30"
        },
        {
          "name": "Mariä Himmelfahrt",
          "start": "2024-08-15"
        },
        {
          "name": "Allerheiligen",
          "start": "2024-11-01"
        }
      ],
      "BE": [
        {
          "name": "Internationaler Frauentag",
          "start": "2024-03-08"
        }
      ],
      "BB": [
        {
          "name": "Reformationstag",
          "start": "2024-10-31"
        }
      ],
      "HB": [
        {
          "name": "Reformationstag",
          "start": "2024-10-31"
        }
      ],
      "HH": [
        {
          "name": "Reformationstag",
          "start": "2024-10-31"
        }
      ],
      "HE": [
        {
          "name": "Fronleichnam",
          "start": "2024-05-30"
        }
      ],
      "MV": [
        {
          "name": "Reformationstag",
          "start": "2024-10-31"
        }
      ],
      "NI": [
        {
          "name": "Reformationstag",
          "start": "2024-10-31"
        }
      ],
      "NW": [
        {
          "name": "Fronleichnam",
          "start": "2024-05-30"
        },
        {
          "name": "Allerheiligen",
          "start": "2024-11-01"
        }
      ],
      "RP": [
        {
          "name": "Fronleichnam",
          "start": "2024-05-30"
        },
        {
          "name": "Allerheiligen",
          "start": "2024-11-01"
        }
      ],
      "SL": [
        {
          "name": "Fronleichnam",
          "start": "2024-05-30"
        },
        {
          "name": "Mariä Himmelfahrt",
          "start": "2024-08-15"
        },
        {
          "name": "Allerheiligen",
          "start": "2024-11-01"
        }
      ],
      "SN": [
        {
          "name": "Reformationstag",
          "start": "2024-10-31"
        },
        {
          "name": "Buß- und Bettag",
          "start": "2024-11-20"
        }
      ],
      "ST": [
        {
          "name": "Heilige Drei Könige",
          "start": "2024-01-06"
        },
        {
          "name": "Reformationstag",
          "start": "2024-10-31"
        }
      ],
      "SH": [
        {
          "name": "Reformationstag",
          "start": "2024-10-31"
        }
      ],
      "TH": [
        {
          "name": "Weltkindertag",
          "start": "2024-09-20"
        },
        {
          "name": "Reformationstag",
          "start": "2024-10-31"
        }
      ]
    },
    "2025": {
      "ALL": [
        {
          "name": "Neujahr",
          "start": "2025-01-01",
          "nationwide": true
        },
        {
          "name": "Karfreitag",
          "start": "2025-04-18",
          "nationwide": true
        },
        {
          "name": "Ostermontag",
          "start": "2025-04-21",
          "nationwide": true
        },
        {
          "name": "Tag der Arbeit",
          "start": "2025-05-01",
          "nationwide": true
        },
        {
          "name": "Christi Himmelfahrt",
          "start": "2025-05-29",
          "nationwide": true
        },
        {
          "name": "Pfingstmontag",
          "start": "2025-06-09",
          "nationwide": true
        },
        {
          "name": "Tag der Deutschen Einheit",
          "start": "2025-10-03",
          "nationwide": true
        },
        {
          "name": "1. Weihnachtstag",
          "start": "2025-12-25",
          "nationwide": true
        },
        {
          "name": "2. Weihnachtstag",
          "start": "2025-12-26",
          "nationwide": true
        }
      ],
      "BW": [
        {
          "name": "Heilige Drei Könige",
          "start": "2025-01-06"
        },
        {
          "name": "Fronleichnam",
          "start": "2025-06-19"
        },
        {
          "name": "Allerheiligen",
          "start": "2025-11-01"
        }
      ],
      "BY": [
        {
          "name": "Heilige Drei Könige",
          "start": "2025-01-06"
        },
        {
          "name": "Fronleichnam",
          "start": "2025-06-19"
        },
        {
          "name": "Mariä Himmelfahrt",
          "start": "2025-08-15"
        },
        {
          "name": "Allerheiligen",
          "start": "2025-11-01"
        }
      ],
      "BE": [
        {
          "name": "Internationaler Frauentag",
          "start": "2025-03-08"
        }
      ],
      "BB": [
        {
          "name": "Reformationstag",
          "start": "2025-10-31"
        }
      ],
      "HB": [
        {
          "name": "Reformationstag",
          "start": "2025-10-31"
        }
      ],
      "HH": [
        {
          "name": "Reformationstag",
          "start": "2025-10-31"
        }
      ],
      "HE": [
        {
          "name": "Fronleichnam",
          "start": "2025-06-19"
        }
      ],
      "MV": [
        {
          "name": "Reformationstag",
          "start": "2025-10-31"
        }
      ],
      "NI": [
        {
          "name": "Reformationstag",
          "start": "2025-10-31"
        }
      ],
      "NW": [
        {
          "name": "Fronleichnam",
          "start": "2025-06-19"
        },
        {
          "name": "Allerheiligen",
          "start": "2025-11-01"
        }
      ],
      "RP": [
        {
          "name": "Fronleichnam",
          "start": "2025-06-19"
        },
        {
          "name": "Allerheiligen",
          "start": "2025-11-01"
        }
      ],
      "SL": [
        {
          "name": "Fronleichnam",
          "start": "2025-06-19"
        },
        {
          "name": "Mariä Himmelfahrt",
          "start": "2025-08-15"
        },
        {
          "name": "Allerheiligen",
          "start": "2025-11-01"
        }
      ],
      "SN": [
        {
          "name": "Reformationstag",
          "start": "2025-10-31"
        },
        {
          "name": "Buß- und Bettag",
          "start": "2025-11-19"
        }
      ],
      "ST": [
        {
          "name": "Heilige Drei Könige",
          "start": "2025-01-06"
        },
        {
          "name": "Reformationstag",
          "start": "2025-10-31"
        }
      ],
      "SH": [
        {
          "name": "Reformationstag",
          "start": "2025-10-31"
        }
      ],
      "TH": [
        {
          "name": "Weltkindertag",
          "start": "2025-09-20"
        },
        {
          "name": "Reformationstag",
          "start": "2025-10-31"
        }
      ]
    },
    "2026": {
      "ALL": [
        {
          "name": "Neujahr",
          "start": "2026-01-01",
          "type": "public"
        },
        {
          "name": "Karfreitag",
          "start": "2026-04-03",
          "type": "public"
        },
        {
          "name": "Ostermontag",
          "start": "2026-04-06",
          "type": "public"
        },
        {
          "name": "Tag der Arbeit",
          "start": "2026-05-01",
          "type": "public"
        },
        {
          "name": "Christi Himmelfahrt",
          "start": "2026-05-14",
          "type": "public"
        },
        {
          "name": "Pfingstmontag",
          "start": "2026-05-25",
          "type": "public"
        },
        {
          "name": "Tag der Deutschen Einheit",
          "start": "2026-10-03",
          "type": "public"
        },
        {
          "name": "1. Weihnachtstag",
          "start": "2026-12-25",
          "type": "public"
        },
        {
          "name": "2. Weihnachtstag",
          "start": "2026-12-26",
          "type": "public"
        }
      ],
      "BW": [
        {
          "name": "Heilige Drei Könige",
          "start": "2026-01-06",
          "type": "public"
        },
        {
          "name": "Fronleichnam",
          "start": "2026-06-04",
          "type": "public"
        },
        {
          "name": "Allerheiligen",
          "start": "2026-11-01",
          "type": "public"
        }
      ],
      "BY": [
        {
          "name": "Heilige Drei Könige",
          "start": "2026-01-06",
          "type": "public"
        },
        {
          "name": "Fronleichnam",
          "start": "2026-06-04",
          "type": "public"
        },
        {
          "name": "Mariä Himmelfahrt",
          "start": "2026-08-15",
          "type": "public"
        },
        {
          "name": "Allerheiligen",
          "start": "2026-11-01",
          "type": "public"
        }
      ],
      "BE": [
        {
          "name": "Internationaler Frauentag",
          "start": "2026-03-08",
          "type": "public"
        }
      ],
      "BB": [
        {
          "name": "Reformationstag",
          "start": "2026-10-31",
          "type": "public"
        }
      ],
      "HB": [
        {
          "name": "Reformationstag",
          "start": "2026-10-31",
          "type": "public"
        }
      ],
      "HH": [
        {
          "name": "Reformationstag",
          "start": "2026-10-31",
          "type": "public"
        }
      ],
      "HE": [
        {
          "name": "Fronleichnam",
          "start": "2026-06-04",
          "type": "public"
        }
      ],
      "MV": [
        {
          "name": "Internationaler Frauentag",
          "start": "2026-03-08",
          "type": "public"
        },
        {
          "name": "Reformationstag",
          "start": "2026-10-31",
          "type": "public"
        }
      ],
      "NI": [
        {
          "name": "Reformationstag",
          "start": "2026-10-31",
          "type": "public"
        }
      ],
      "NW": [
        {
          "name": "Fronleichnam",
          "start": "2026-06-04",
          "type": "public"
        },
        {
          "name": "Allerheiligen",
          "start": "2026-11-01",
          "type": "public"
        }
      ],
      "RP": [
        {
          "name": "Fronleichnam",
          "start": "2026-06-04",
          "type": "public"
        },
        {
          "name": "Allerheiligen",
          "start": "2026-11-01",
          "type": "public"
        }
      ],
      "SL": [
        {
          "name": "Fronleichnam",
          "start": "2026-06-04",
          "type": "public"
        },
        {
          "name": "Mariä Himmelfahrt",
          "start": "2026-08-15",
          "type": "public"
        },
        {
          "name": "Allerheiligen",
          "start": "2026-11-01",
          "type": "public"
        }
      ],
      "SN": [
        {
          "name": "Reformationstag",
          "start": "2026-10-31",
          "type": "public"
        },
        {
          "name": "Buß- und Bettag",
          "start": "2026-11-18",
          "type": "public"
        }
      ],
      "ST": [
        {
          "name": "Heilige Drei Könige",
          "start": "2026-01-06",
          "type": "public"
        },
        {
          "name": "Reformationstag",
          "start": "2026-10-31",
          "type": "public"
        }
      ],
      "SH": [
        {
          "name": "Reformationstag",
          "start": "2026-10-31",
          "type": "public"
        }
      ],
      "TH": [
        {
          "name": "Weltkindertag",
          "start": "2026-09-20",
          "type": "public"
        },
        {
          "name": "Reformationstag",
          "start": "2026-10-31",
          "type": "public"
        }
      ]
    },
    "2027": {
      "ALL": [
        {
          "name": "Neujahr",
          "start": "2027-01-01",
          "nationwide": true
        },
        {
          "name": "Karfreitag",
          "start": "2027-03-26",
          "nationwide": true
        },
        {
          "name": "Ostermontag",
          "start": "2027-03-29",
          "nationwide": true
        },
        {
          "name": "Tag der Arbeit",
          "start": "2027-05-01",
          "nationwide": true
        },
        {
          "name": "Christi Himmelfahrt",
          "start": "2027-05-06",
          "nationwide": true
        },
        {
          "name": "Pfingstmontag",
          "start": "2027-05-17",
          "nationwide": true
        },
        {
          "name": "Tag der Deutschen Einheit",
          "start": "2027-10-03",
          "nationwide": true
        },
        {
          "name": "1. Weihnachtstag",
          "start": "2027-12-25",
          "nationwide": true
        },
        {
          "name": "2. Weihnachtstag",
          "start": "2027-12-26",
          "nationwide": true
        }
      ],
      "BW": [
        {
          "name": "Heilige Drei Könige",
          "start": "2027-01-06"
        },
        {
          "name": "Fronleichnam",
          "start": "2027-05-27"
        },
        {
          "name": "Allerheiligen",
          "start": "2027-11-01"
        }
      ],
      "BY": [
        {
          "name": "Heilige Drei Könige",
          "start": "2027-01-06"
        },
        {
          "name": "Fronleichnam",
          "start": "2027-05-27"
        },
        {
          "name": "Mariä Himmelfahrt",
          "start": "2027-08-15"
        },
        {
          "name": "Allerheiligen",
          "start": "2027-11-01"
        }
      ],
      "BE": [
        {
          "name": "Internationaler Frauentag",
          "start": "2027-03-08"
        }
      ],
      "BB": [
        {
          "name": "Reformationstag",
          "start": "2027-10-31"
        }
      ],
      "HB": [
        {
          "name": "Reformationstag",
          "start": "2027-10-31"
        }
      ],
      "HH": [
        {
          "name": "Reformationstag",
          "start": "2027-10-31"
        }
      ],
      "HE": [
        {
          "name": "Fronleichnam",
          "start": "2027-05-27"
        }
      ],
      "MV": [
        {
          "name": "Internationaler Frauentag",
          "start": "2027-03-08"
        },
        {
          "name": "Reformationstag",
          "start": "2027-10-31"
        }
      ],
      "NI": [
        {
          "name": "Reformationstag",
          "start": "2027-10-31"
        }
      ],
      "NW": [
        {
          "name": "Fronleichnam",
          "start": "2027-05-27"
        },
        {
          "name": "Allerheiligen",
          "start": "2027-11-01"
        }
      ],
      "RP": [
        {
          "name": "Fronleichnam",
          "start": "2027-05-27"
        },
        {
          "name": "Allerheiligen",
          "start": "2027-11-01"
        }
      ],
      "SL": [
        {
          "name": "Fronleichnam",
          "start": "2027-05-27"
        },
        {
          "name": "Mariä Himmelfahrt",
          "start": "2027-08-15"
        },
        {
          "name": "Allerheiligen",
          "start": "2027-11-01"
        }
      ],
      "SN": [
        {
          "name": "Reformationstag",
          "start": "2027-10-31"
        },
        {
          "name": "Buß- und Bettag",
          "start": "2027-11-17"
        }
      ],
      "ST": [
        {
          "name": "Heilige Drei Könige",
          "start": "2027-01-06"
        },
        {
          "name": "Reformationstag",
          "start": "2027-10-31"
        }
      ],
      "SH": [
        {
          "name": "Reformationstag",
          "start": "2027-10-31"
        }
      ],
      "TH": [
        {
          "name": "Weltkindertag",
          "start": "2027-09-20"
        },
        {
          "name": "Reformationstag",
          "start": "2027-10-31"
        }
      ]
    }
  }
};
